import * as handlers from './handlers'

export const initialState = (request: Request) =>
  Object.values(handlers).reduce(
    (acc, handler) => acc || handler(request),
    undefined,
  )
